import { Component, OnInit } from '@angular/core';
import { JaakrecogLivenessLibService } from './jaakrecog-liveness-lib.service';

@Component({
  selector: 'ngx-jaakrecog-liveness-lib',
  template: `
    <p>
      jaakrecog-liveness-lib works!
    </p>
  `,
  styles: [
  ]
})
export class JaakrecogLivenessLibComponent implements OnInit {

  constructor(
  ) { }

  ngOnInit(): void {
  }

}
